import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import { useState, useEffect } from "react";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import TesseramentoPage from "@/pages/TesseramentoPage";
import BonusPage from "@/pages/BonusPage";
import UtilityPage from "@/pages/UtilityPage";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import CursorTrail from "@/components/CursorTrail";
import ConsensoPrivacy from "@/components/ConsensoPrivacy";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [privacyOk, setPrivacyOk] = useState(() => sessionStorage.getItem('ugl_privacy') === 'true');

  useEffect(() => {
    if (user && !privacyOk) {
      axios.get(`${API}/auth/privacy-status`).then(r => {
        const ok = r.data.accettata;
        setPrivacyOk(ok);
        if (ok) sessionStorage.setItem('ugl_privacy', 'true');
      }).catch(() => setPrivacyOk(false));
    }
  }, [user, privacyOk]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f1d32]">
        <div className="animate-pulse flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-full border-3 border-[#C9A84C] border-t-transparent animate-spin" />
          <p className="text-sm text-white/40">Caricamento...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (privacyOk === null) return <div className="min-h-screen bg-[#0f1d32]" />;
  if (!privacyOk) return <ConsensoPrivacy onAccept={() => { setPrivacyOk(true); sessionStorage.setItem('ugl_privacy', 'true'); }} />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <CursorTrail />
        <AccessibilityWidget />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/tesseramento" element={<TesseramentoPage />} />
          <Route path="/bonus" element={<BonusPage />} />
          <Route path="/utility" element={<UtilityPage />} />
          <Route path="/strumenti" element={<UtilityPage />} />
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
